var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 91,
    viewBox: "0 0 187 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.4444 16.0417V60.0735C57.4444 63.229 54.8863 65.7872 51.7308 65.7872C48.5726 65.7872 46.0117 63.229 46.0117 60.0735V16.0417C46.0117 12.8862 48.5699 10.3281 51.7308 10.3281C54.8835 10.3253 57.4444 12.8862 57.4444 16.0417Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.734 20.8391L133.499 19.1754L128.202 19.9418L126.921 22.3636L118.698 37.56L109.954 53.7081L109.927 53.7545L109.597 54.3681L109.469 54.6054L112.376 56.3072L121.144 56.8254L122.571 54.3681H122.584L131.099 38.64L139.66 22.8218L140.734 20.8391Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.516 16.1018C142.516 17.0836 142.268 18.0136 141.826 18.8208L140.209 21.8099H112.991C109.835 21.8099 107.285 19.2545 107.285 16.1045C107.285 12.9545 109.838 10.3963 112.991 10.3963H136.811C139.961 10.3963 142.516 12.9518 142.516 16.1018Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.516 60.0763C142.516 63.2318 139.961 65.7873 136.811 65.7873H112.991C109.835 65.7873 107.285 63.2318 107.285 60.0763C107.285 59.2118 107.479 58.3936 107.822 57.66L107.842 57.6273L107.85 57.6054V57.6L108.112 57.1227V57.1173L109.598 54.3682H136.811C139.961 54.3682 142.516 56.9236 142.516 60.0763Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M184.165 21.0873L176.177 19.7155L170.97 20.6618V21.4527L170.518 22.3064L162.262 37.56L153.161 54.3682L152.676 55.2655L154.015 56.8255L165.868 54.8536L166.143 54.3682H166.149L166.209 54.2564L166.369 53.9591L174.663 38.64L183.161 22.9391L184.165 21.0873Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M186.079 16.1018C186.079 17.0836 185.83 18.0136 185.389 18.8208L183.771 21.8099H156.553C153.398 21.8099 150.848 19.2545 150.848 16.1045C150.848 12.9545 153.4 10.3963 156.553 10.3963H180.373C183.523 10.3963 186.079 12.9518 186.079 16.1018Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M186.079 60.0763C186.079 63.2318 183.523 65.7873 180.373 65.7873H156.553C153.398 65.7873 150.848 63.2318 150.848 60.0763C150.848 59.2118 151.041 58.3936 151.385 57.66L151.404 57.6273L151.412 57.6054V57.6L151.674 57.1227V57.1173L153.16 54.3682H180.373C183.523 54.3682 186.079 56.9236 186.079 60.0763Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.794 43.4126C149.807 43.4126 152.249 40.9705 152.249 37.9581C152.249 34.9456 149.807 32.5035 146.794 32.5035C143.782 32.5035 141.34 34.9456 141.34 37.9581C141.34 40.9705 143.782 43.4126 146.794 43.4126Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1902 40.5191L18.1712 40.3282C18.1357 39.7937 18.0975 39.2537 18.0484 38.7191C17.3012 29.8173 14.9066 21.3709 11.173 13.6855C11.173 13.6855 11.173 13.6855 11.1675 13.68C11.0857 13.5082 11.0039 13.3391 10.9193 13.1728C10.8839 13.0991 10.8457 13.0228 10.8102 12.9519C10.7284 12.7964 10.6384 12.6437 10.543 12.4991C10.5375 12.4909 10.5348 12.48 10.5293 12.4773C9.65115 11.1409 8.21933 10.1755 6.50388 9.94912C3.36479 9.52094 0.479332 11.7219 0.0511503 14.8637C-0.071577 15.7937 0.0293321 16.6937 0.323878 17.5228C0.323878 17.5282 0.329332 17.5364 0.332059 17.5446C0.413878 17.7109 0.490241 17.88 0.563878 18.0519C0.623878 18.1691 0.672969 18.2864 0.722059 18.4091C0.727514 18.4173 0.730241 18.4282 0.735696 18.4364C0.866605 18.7173 0.989332 19.0037 1.11206 19.2873C1.1857 19.4591 1.2566 19.6309 1.33024 19.8082C1.45842 20.0973 1.5757 20.3919 1.69297 20.6919C1.72024 20.7546 1.74751 20.8173 1.77479 20.8855C1.91933 21.2482 2.06115 21.6109 2.20024 21.9764C2.21933 22.0228 2.2357 22.0664 2.24933 22.1128C2.39388 22.4891 2.5357 22.8655 2.67206 23.2446C2.70479 23.34 2.74024 23.4382 2.7757 23.5391C2.91206 23.9291 3.04842 24.3191 3.17933 24.7119C3.28297 25.0255 3.38388 25.3364 3.48206 25.65C3.57751 25.9309 3.66206 26.2119 3.74933 26.4982C3.86388 26.8609 3.96751 27.2291 4.07115 27.5946C4.18024 27.9628 4.28388 28.3337 4.38479 28.7046C4.4666 28.9937 4.54024 29.28 4.61115 29.5691C4.67933 29.8173 4.73933 30.0682 4.80206 30.3164C4.97388 31.0146 5.13751 31.7155 5.28206 32.4246C5.33115 32.6509 5.38297 32.8773 5.42388 33.1037C5.50024 33.4528 5.56842 33.7964 5.63115 34.1455C6.9866 41.3455 7.24024 48.8755 6.23933 56.5282C6.2257 56.6319 6.21206 56.7409 6.19842 56.8446C6.17933 56.9919 6.15751 57.1364 6.13842 57.2809V57.2837V57.2891C6.1357 57.3164 6.13024 57.3409 6.12751 57.3682C6.13024 57.3628 6.13297 57.3573 6.13297 57.3519L6.05933 58.4373C6.05933 58.4373 7.94388 58.4455 8.0366 58.3528C8.12933 58.26 11.1593 56.01 11.1593 56.01L18.3648 40.9446L18.1902 40.5191Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5689 15.9138V15.9766C37.5607 16.162 37.547 16.3448 37.5334 16.5329C36.4643 32.962 29.8234 47.8748 19.4925 59.4057C18.658 60.3384 16.0889 62.7902 15.9907 62.9075C15.0116 64.0257 13.667 64.8438 12.0743 64.9884C11.9325 65.002 11.7934 65.0102 11.657 65.0157C8.67886 65.0757 6.10977 62.8175 5.83432 59.8038C5.82068 59.6757 5.8125 59.5447 5.8125 59.4193C5.92705 58.7429 6.03068 58.0638 6.12886 57.3793C6.34977 56.7411 6.68523 56.152 7.10795 55.6393C7.11614 55.6311 7.12159 55.6202 7.12705 55.6175C7.28523 55.4538 7.44068 55.2875 7.59886 55.1184C7.60705 55.1047 7.6125 55.0993 7.62068 55.0911C8.55341 54.0847 9.45614 53.0566 10.3261 52.0011C12.7098 49.1157 14.8725 46.0366 16.7761 42.8047C17.2616 41.9893 17.728 41.1629 18.1752 40.3257C18.3416 40.012 18.5107 39.7011 18.6743 39.382C22.5089 31.9938 25.078 23.8884 26.1252 15.3629C26.1307 15.2811 26.1389 15.1993 26.1525 15.1229C26.1525 15.1011 26.158 15.0766 26.1607 15.0602C26.5425 12.5048 28.618 10.4429 31.3043 10.1975C34.4625 9.90294 37.2552 12.2266 37.5498 15.382C37.5634 15.562 37.5689 15.742 37.5689 15.9138Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1627 10.3255C22.014 10.3255 24.3255 8.01402 24.3255 5.16273C24.3255 2.31143 22.014 0 19.1627 0C16.3114 0 14 2.31143 14 5.16273C14 8.01402 16.3114 10.3255 19.1627 10.3255Z",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5869 53.5607L87.4915 53.5989C85.9397 54.0925 84.2924 54.3544 82.5797 54.3544C80.8097 54.3544 79.1024 54.0707 77.5015 53.5444L77.4306 53.5171L76.9478 53.2935L75.9688 55.7644L77.2887 64.5135L77.4388 64.9553L77.496 64.9744H77.4988L77.6106 65.0098V65.0071C79.1788 65.5116 80.8506 65.7844 82.5797 65.7844C82.7242 65.7844 82.8633 65.7844 83.0051 65.7789H83.0542C83.3978 65.7707 83.7415 65.7462 84.0797 65.7162C84.0933 65.7162 84.1015 65.7162 84.1151 65.7107C85.2797 65.5989 86.3978 65.3726 87.4751 65.0316V65.0344L87.5515 65.0098L88.1297 64.3689L87.5869 53.5607Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9534 16.0417V51.2044C98.7244 52.9881 98.2171 54.679 97.4807 56.2417C95.8062 59.7981 92.9316 62.6644 89.3916 64.2981C88.7862 64.5735 88.1643 64.8162 87.5234 65.0208V16.0417C87.5234 12.8835 90.0789 10.3281 93.2371 10.3281C96.3953 10.3253 98.9534 12.8808 98.9534 16.0417Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4937 16.0417V64.9744C76.8664 64.7726 76.2609 64.5272 75.6691 64.2517C72.14 62.5963 69.2819 59.7108 67.6319 56.1408C66.6255 53.9753 66.0664 51.5563 66.0664 49.0008V16.0417C66.0664 12.8835 68.6246 10.3281 71.78 10.3281C74.9355 10.3253 77.4937 12.8808 77.4937 16.0417Z",
    fill: "url(#paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M175.94 90.3493C175.487 89.4492 108 90.3805 108 90.3805L119.774 72.3458H186C186 72.3458 176.393 91.2495 175.94 90.3493Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M132.477 82.2184C132.403 82.2555 132.403 82.2927 132.477 82.3299C133.654 82.9368 134.242 83.9463 134.242 85.3584C134.242 86.5599 133.833 87.4703 133.016 88.0896C132.198 88.6965 131.127 89 129.802 89H124.989C124.927 89 124.872 88.9814 124.822 88.9443C124.785 88.8947 124.766 88.839 124.766 88.777V76.2171C124.766 76.1552 124.785 76.1056 124.822 76.0685C124.872 76.0189 124.927 75.9941 124.989 75.9941H129.653C132.589 75.9941 134.056 77.1832 134.056 79.5615C134.056 80.8001 133.53 81.6858 132.477 82.2184ZM127.479 78.2423C127.417 78.2423 127.386 78.2733 127.386 78.3352V81.2336C127.386 81.2956 127.417 81.3265 127.479 81.3265H129.653C130.235 81.3265 130.687 81.1903 131.009 80.9178C131.331 80.6453 131.492 80.2737 131.492 79.803C131.492 79.3199 131.331 78.9421 131.009 78.6696C130.687 78.3847 130.235 78.2423 129.653 78.2423H127.479ZM129.802 86.7333C130.371 86.7333 130.817 86.5908 131.139 86.3059C131.461 86.0087 131.622 85.6061 131.622 85.0982C131.622 84.5904 131.461 84.194 131.139 83.9091C130.817 83.6119 130.365 83.4632 129.783 83.4632H127.479C127.417 83.4632 127.386 83.4942 127.386 83.5561V86.6404C127.386 86.7023 127.417 86.7333 127.479 86.7333H129.802ZM146.061 78.0193C146.061 78.0813 146.036 78.137 145.987 78.1866C145.95 78.2237 145.9 78.2423 145.838 78.2423H139.744C139.682 78.2423 139.651 78.2733 139.651 78.3352V81.2151C139.651 81.277 139.682 81.308 139.744 81.308H143.739C143.801 81.308 143.85 81.3327 143.887 81.3823C143.937 81.4194 143.962 81.469 143.962 81.5309V83.3332C143.962 83.3951 143.937 83.4508 143.887 83.5004C143.85 83.5375 143.801 83.5561 143.739 83.5561H139.744C139.682 83.5561 139.651 83.5871 139.651 83.649V86.6589C139.651 86.7209 139.682 86.7518 139.744 86.7518H145.838C145.9 86.7518 145.95 86.7766 145.987 86.8262C146.036 86.8633 146.061 86.9129 146.061 86.9748V88.777C146.061 88.839 146.036 88.8947 145.987 88.9443C145.95 88.9814 145.9 89 145.838 89H137.254C137.192 89 137.137 88.9814 137.087 88.9443C137.05 88.8947 137.031 88.839 137.031 88.777V76.2171C137.031 76.1552 137.05 76.1056 137.087 76.0685C137.137 76.0189 137.192 75.9941 137.254 75.9941H145.838C145.9 75.9941 145.95 76.0189 145.987 76.0685C146.036 76.1056 146.061 76.1552 146.061 76.2171V78.0193ZM157.599 75.9941C157.661 75.9941 157.71 76.0189 157.747 76.0685C157.797 76.1056 157.822 76.1552 157.822 76.2171V78.0379C157.822 78.0999 157.797 78.1556 157.747 78.2051C157.71 78.2423 157.661 78.2609 157.599 78.2609H154.273C154.211 78.2609 154.18 78.2918 154.18 78.3538V88.777C154.18 88.839 154.155 88.8947 154.106 88.9443C154.069 88.9814 154.019 89 153.957 89H151.783C151.721 89 151.666 88.9814 151.616 88.9443C151.579 88.8947 151.56 88.839 151.56 88.777V78.3538C151.56 78.2918 151.529 78.2609 151.467 78.2609H148.235C148.173 78.2609 148.117 78.2423 148.067 78.2051C148.03 78.1556 148.012 78.0999 148.012 78.0379V76.2171C148.012 76.1552 148.03 76.1056 148.067 76.0685C148.117 76.0189 148.173 75.9941 148.235 75.9941H157.599ZM167.307 89C167.183 89 167.103 88.9381 167.065 88.8142L166.508 86.9934C166.483 86.9438 166.452 86.9191 166.415 86.9191H161.844C161.807 86.9191 161.776 86.9438 161.752 86.9934L161.213 88.8142C161.176 88.9381 161.095 89 160.971 89H158.612C158.537 89 158.482 88.9814 158.444 88.9443C158.407 88.8947 158.401 88.8266 158.426 88.7399L162.439 76.1799C162.476 76.0561 162.557 75.9941 162.681 75.9941H165.598C165.721 75.9941 165.802 76.0561 165.839 76.1799L169.852 88.7399C169.865 88.7647 169.871 88.7956 169.871 88.8328C169.871 88.9443 169.803 89 169.667 89H167.307ZM162.42 84.7824C162.408 84.8567 162.433 84.8939 162.495 84.8939H165.765C165.839 84.8939 165.864 84.8567 165.839 84.7824L164.167 79.2642C164.155 79.2146 164.136 79.1961 164.111 79.2084C164.086 79.2084 164.068 79.227 164.055 79.2642L162.42 84.7824Z",
    fill: "#202A58"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 46.0109,
    y1: 38.0566,
    x2: 57.4433,
    y2: 38.0566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2866,
    stopColor: "#FB8404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE1E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 109.469,
    y1: 37.9998,
    x2: 140.733,
    y2: 37.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.1024e-7,
    stopColor: "#FB8404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "#FE1E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 107.285,
    y1: 16.1025,
    x2: 142.517,
    y2: 16.1025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2866,
    stopColor: "#FB8404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE1E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 107.285,
    y1: 60.0778,
    x2: 142.517,
    y2: 60.0778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2866,
    stopColor: "#FB8404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE1E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 152.675,
    y1: 38.2704,
    x2: 184.164,
    y2: 38.2704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.1024e-7,
    stopColor: "#FB8404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "#FE1E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 150.847,
    y1: 16.1025,
    x2: 186.08,
    y2: 16.1025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2866,
    stopColor: "#FB8404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE1E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 150.847,
    y1: 60.0778,
    x2: 186.08,
    y2: 60.0778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2866,
    stopColor: "#FB8404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE1E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 141.34,
    y1: 37.9589,
    x2: 152.249,
    y2: 37.9589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2866,
    stopColor: "#FB8404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE1E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: -7.55813,
    y1: 16.8845,
    x2: 57.1398,
    y2: 92.5689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.1024e-7,
    stopColor: "#FB8404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "#FE1E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 28.3073,
    y1: 29.2785,
    x2: -25.0553,
    y2: 106.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6714,
    stopColor: "#FB8404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE1E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 13.9986,
    y1: 5.16349,
    x2: 24.3248,
    y2: 5.16349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2866,
    stopColor: "#FB8404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE1E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 82.0481,
    y1: 52.9893,
    x2: 82.0481,
    y2: 73.7862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.66389e-7,
    stopColor: "#FB8404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    stopColor: "#FE1E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 93.2407,
    y1: 10.3265,
    x2: 93.2407,
    y2: 65.0194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6669,
    stopColor: "#FB8404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE1E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 71.7808,
    y1: 10.3265,
    x2: 71.7808,
    y2: 64.9743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6669,
    stopColor: "#FB8404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE1E14"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBeta);
export default __webpack_public_path__ + "static/media/logo-beta.216cb0b04a316bc296cc7ecabde0303a.svg";
export { ForwardRef as ReactComponent };